<template>
  <section class="certiface-verify">
    <div v-html="messages[0].text" />

    <a
      :href="messages[1].href"
      class="donation-nav donation-nav--forward"
    >{{ messages[1].text }}</a>
  </section>
</template>

<script>
	export default {
		name: 'CertFaceVerify',
		data() {
			return {
				loading: false,
        dataBusyMessage: '',
				errorMessage: '',

				validation: {
					errors: {},
				},
			};
		},
		computed: {
			username() {
				return this.$store.state.username;
			},
			messages() {
				return this.$store.state.messages;
			},
			candidate() {
				return this.getMergeCandidate.candidate;
			},
			getMergeCandidate() {
				return this.$store.getters.generateCandidateObject;
			},
		},
		mounted() {
			this.scrollToDonate();
		},
		methods: {
			goBack() {
				this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'boleto' });
			},
			scrollToDonate() {
				const form = document.getElementById('doar');
				form.scrollIntoView({ block: 'start', behavior: 'smooth' });
			},
      toggleLoading(message = '') {
        this.loading = !this.loading;

        this.dataBusyMessage = this.dataBusyMessage !== message
          ? message
          : '';
      },

			handleErrorMessage(err) {
				this.errorMessage = err.data[0].message;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascript/components/steps/certFaceVerify.vue